var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBlogFree(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_1973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1828 1.59379C28.9853 2.3966 28.9853 3.68918 28.1828 4.49199L17.4188 15.2593L13.9659 15.815L14.5215 12.3611L25.2855 1.59379C26.088 0.790983 27.3803 0.79102 28.1828 1.59379Z",
    stroke: "#2064A1",
    strokeWidth: 2.00001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6545 21.1897H14.4449",
    stroke: "#2064A1",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6545 24.9766H19.2525",
    stroke: "#2064A1",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87695 9.78857C2.28313 9.78857 1 11.0686 1 12.6597V14.7808H6.75391",
    stroke: "#2064A1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0938 9.78857H3.87695C5.47086 9.78857 6.75391 11.0686 6.75391 12.6597V14.7808V28.9995H23.1465V12.6597C23.1465 11.7986 22.7615 11.0387 22.1641 10.5132",
    stroke: "#2064A1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0583 2.82129L29.0003 7.76473L25.4956 11.2705",
    stroke: "#2064A1",
    strokeWidth: 2.00001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_1973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.0002,
    height: 29.9994,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlogFree);
export default __webpack_public_path__ + "static/media/icon_blog_free.9a44072a95d49afb4900d56f8269f381.svg";
export { ForwardRef as ReactComponent };